module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "bulletins-button",
    on: {
      "click": _vm.toggleBulletins
    }
  }, [_c('i', {
    staticClass: "fa fa-bell"
  }), _vm._v(" "), (_vm.newBulletins) ? _c('span', {
    staticClass: "badge"
  }, [_vm._v(_vm._s(_vm.newBulletins))]) : _vm._e()]), _vm._v(" "), (_vm.open) ? _c('div', {
    staticClass: "bulletinsOutside",
    on: {
      "click": _vm.toggleBulletins
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "bulletins",
    class: {
      open: _vm.open
    },
    attrs: {
      "tabindex": "0"
    }
  }, [_c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "left"
  }, [(_vm.settings) ? _c('h4', [_vm._v("Notification Settings")]) : _c('h4', [_vm._v(_vm._s(_vm.archives ? "Archived" : "") + " Notifications")]), _vm._v(" "), (!_vm.settings && _vm.archives) ? _c('div', [_vm._v("( "), _c('span', {
    on: {
      "click": _vm.getBulletins
    }
  }, [_vm._v("Back")]), _vm._v(" )")]) : _vm._e(), _vm._v(" "), (_vm.settings) ? _c('div', [_vm._v("( "), _c('span', {
    on: {
      "click": _vm.toggleSettings
    }
  }, [_vm._v("Back")]), _vm._v(" )")]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.headerDropdown && !_vm.settings),
      expression: "headerDropdown && !settings"
    }],
    staticClass: "headerDropdown"
  }, [_c('div', {
    on: {
      "click": _vm.markAllAsActedOn
    }
  }, [_vm._v("Mark all as read")]), _vm._v(" "), (!_vm.archives) ? _c('div', {
    on: {
      "click": _vm.markAllAsArchived
    }
  }, [_vm._v("Archive all")]) : _vm._e(), _vm._v(" "), (!_vm.archives) ? _c('div', {
    on: {
      "click": _vm.getArchivedBulletins
    }
  }, [_vm._v("\n          Show archives\n        ")]) : _c('div', {
    on: {
      "click": _vm.getBulletins
    }
  }, [_vm._v("Exit archives")])]), _vm._v(" "), _c('div', {
    staticClass: "icons"
  }, [(!_vm.settings) ? _c('span', {
    staticClass: "fa-stack"
  }, [_c('i', {
    staticClass: "fa fa-circle fa-stack-1x icon-background"
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-ellipsis-v fa-stack-1x icon",
    on: {
      "click": _vm.toggleHeaderDropdown
    }
  })]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "fa-stack"
  }, [_c('i', {
    staticClass: "fa fa-circle fa-stack-1x icon-background"
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-gear fa-stack-1x icon",
    on: {
      "click": _vm.toggleSettings
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "fa-stack"
  }, [_c('i', {
    staticClass: "fa fa-circle fa-stack-1x icon-background"
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-times fa-stack-1x icon",
    on: {
      "click": _vm.toggleBulletins
    }
  })])])]), _vm._v(" "), (_vm.settings) ? _c('bulletin-settings') : _c('ul', {
    staticClass: "content"
  }, [_vm._l((_vm.uniqueBulletins), function(bulletin, $index) {
    return _c('li', {
      key: bulletin.id
    }, [_c('a', {
      staticClass: "bulletin",
      class: {
        noclick: !bulletin.link
      },
      attrs: {
        "href": bulletin.link ? _vm.baseUrl + bulletin.link : ''
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.toggleActedOn(bulletin.id, $index, true), _vm.open = !bulletin.link, _vm.goto(bulletin.link)
        }
      }
    }, [_c('div', {
      staticClass: "image"
    }, [_c('img', {
      staticClass: "avatar",
      attrs: {
        "src": bulletin.avatar
      }
    }), _vm._v(" "), _c('img', {
      staticClass: "icon",
      attrs: {
        "src": bulletin.icon
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "text",
      class: {
        unclicked: !bulletin.actedOn
      }
    }, [_vm._v("\n            " + _vm._s(bulletin.text) + "\n\n            "), _c('div', {
      staticClass: "meta"
    }, [_vm._v("\n              " + _vm._s(_vm._f("timeago")(bulletin.createdAt)) + "\n              "), _c('span', {
      staticClass: "fa-stack"
    }, [_c('i', {
      staticClass: "fa fa-circle fa-stack-1x icon-background"
    }), _vm._v(" "), _c('i', {
      staticClass: "fa fa-ellipsis-h fa-stack-1x icon",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          _vm.toggleBulletinDropdown(bulletin.id)
        }
      }
    })]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.openBulletin == bulletin.id),
        expression: "openBulletin == bulletin.id"
      }],
      ref: 'bd' + bulletin.id,
      refInFor: true,
      staticClass: "bulletinDropdown",
      attrs: {
        "tabindex": "1"
      },
      on: {
        "focusout": _vm.bulletinDropdownOutsideClick
      }
    }, [_c('div', {
      on: {
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          _vm.toggleActedOn(bulletin.id, $index, !bulletin.actedOn)
        }
      }
    }, [_vm._v("\n                  Mark as " + _vm._s(bulletin.actedOn ? "unread" : "read") + "\n                ")]), _vm._v(" "), _c('div', {
      on: {
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          _vm.toggleArchived(bulletin.id, $index)
        }
      }
    }, [_vm._v("\n                  " + _vm._s(bulletin.archived ? "Unarchive" : "Archive") + "\n                ")])])])]), _vm._v(" "), _c('div', [_c('i', {
      staticClass: "fa fa-circle",
      class: {
        unread: !bulletin.actedOn
      }
    })])])])
  }), _vm._v(" "), (_vm.areMore) ? _c('li', {
    staticClass: "load-more",
    on: {
      "click": _vm.loadMore
    }
  }, [_vm._v("Load More")]) : _vm._e()], 2)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-763f3a92!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/Bulletins.vue
// module id = 2083
// module chunks = 2